  <div class="section-content">
    <tgrid-economic-cost-per-customer-widget />
  </div>
  <div class="section-content">
    <tgrid-economic-cost-total-widget />
  </div>
  <div class="section-content">
    <tgrid-cost-outage-counties-calculated-widget />
  </div>
  <div class="section-content">
    <tgrid-cost-outage-residential-cost-widget />
  </div>
  <div class="section-content">
    <tgrid-economic-cost-ranking-widget />
  </div>
